import { NOTE_COLORS } from '@/enums/noteColor';
import type { Note, NoteId } from '@/types/note';
import { asNoteId } from '@/utils/id';
import {
  MAX_NOTE_SIZE,
  MIN_NOTE_SIZE,
  NOTE_TEXT_MAX_LENGTH,
} from '@/constants/notes';
import { array, number, oneOf, shape, string } from './core';
import type { Validator } from './core';

const idValidator: Validator<NoteId> = (input, path) => {
  const r = string({ min: 1, max: 128 })(input, path);
  return r.ok ? { ok: true, value: asNoteId(r.value) } : r;
};

const colorValidator = oneOf(NOTE_COLORS as readonly string[]);

const positiveInt = number({ int: true, min: 0 });

const noteShape = shape({
  id: idValidator,
  x: number({ finite: true }),
  y: number({ finite: true }),
  width: number({ min: MIN_NOTE_SIZE.width, max: MAX_NOTE_SIZE.width }),
  height: number({ min: MIN_NOTE_SIZE.height, max: MAX_NOTE_SIZE.height }),
  color: colorValidator,
  text: string({ max: NOTE_TEXT_MAX_LENGTH }),
  zIndex: positiveInt,
  version: positiveInt,
  createdAt: positiveInt,
  updatedAt: positiveInt,
});

export const noteSchema: Validator<Note> = (input, path) => {
  const r = noteShape(input, path);
  return r.ok ? { ok: true, value: r.value as unknown as Note } : r;
};

export const noteArraySchema = array(noteSchema);

const createShape = shape({
  x: number({ finite: true }),
  y: number({ finite: true }),
  width: number({ min: MIN_NOTE_SIZE.width, max: MAX_NOTE_SIZE.width }),
  height: number({ min: MIN_NOTE_SIZE.height, max: MAX_NOTE_SIZE.height }),
  color: colorValidator,
  text: string({ max: NOTE_TEXT_MAX_LENGTH }),
});

export const createNoteInputSchema = createShape;

export const noteTextSchema = string({ max: NOTE_TEXT_MAX_LENGTH });
